import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { FooterModel } from '../models/footer.model';

@Injectable({
  providedIn: 'root'
})
export class FooterService {

  infoController: string = "/api/Info";

  constructor(private http: HttpClient) { }

  getInfo(): Observable<FooterModel> {
    return this.http.get<FooterModel>(this.infoController + '/GetInfo').
      pipe(
        map(
          data => { return data; }
        ));
  }
}
